import React, { createContext, useReducer } from 'react';
import { AuthActions, AuthReducer } from './AuthReducer';
export type TUser = {
    email: string;
    name: string;
    accessToken: string;
    id: string;
};
export type InitialStateType = {
    isAuthenticated: boolean;
    user: TUser;
};

interface IAuthContext {
    state: InitialStateType;
    dispatch: React.Dispatch<AuthActions>;
}
const localUserData = localStorage.getItem('user');
const initialState = localUserData
    ? JSON.parse(localUserData)
    : {
          isAuthenticated: false,
          user: {
              email: '',
              name: '',
              accessToken: '',
              id: '',
          },
      };

const AuthContext = createContext<IAuthContext>({
    state: initialState,
    dispatch: () => null,
});

const AuthProvider: React.FC = ({ children }): React.ReactElement => {
    const [state, dispatch] = useReducer(AuthReducer, initialState);
    const value = { state, dispatch };
    return <AuthContext.Provider value={value as IAuthContext}>{children}</AuthContext.Provider>;
};

export { AuthContext, AuthProvider, initialState };
